const MapChart = () => {
  return '';
};

export default MapChart;
